/*
 * Lumedi - gedrag van sections/product-info.liquid: pillen die naar een kopje
 * springen, de afgekapte omschrijving, de uitklapkoppen op mobiel en de video
 * die pas na een klik laadt.
 */
(function () {
  var MOBILE_QUERY = "(max-width: 989px)";
  var SCROLL_GAP = 20;

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function stickyHeaderHeight() {
    var header = document.querySelector(".page-header");
    if (!header) return 0;

    var position = window.getComputedStyle(header).position;
    if (position !== "fixed" && position !== "sticky") return 0;

    return header.getBoundingClientRect().height;
  }

  function scrollToHeading(heading) {
    var offset = stickyHeaderHeight() + SCROLL_GAP;
    var target =
      window.pageYOffset + heading.getBoundingClientRect().top - offset;

    // Verder dan de onderkant van de pagina kan niet.
    var maxScroll = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight,
    );
    target = Math.min(Math.max(target, 0), maxScroll);

    if (Math.abs(target - window.pageYOffset) < 1) return;

    window.scrollTo({
      top: target,
      behavior: prefersReducedMotion() ? "auto" : "smooth",
    });
  }

  function setupSections(root) {
    var sections = Array.prototype.slice.call(
      root.querySelectorAll("[data-lumedi-collapsible]"),
    );
    var mobile = window.matchMedia(MOBILE_QUERY);

    function apply() {
      sections.forEach(function (section) {
        var head = section.querySelector(".lumedi-product-info__section-head");
        var body = section.querySelector(".lumedi-product-info__section-body");
        if (!head || !body) return;

        if (!mobile.matches) {
          head.removeAttribute("aria-expanded");
          body.hidden = false;
          return;
        }

        // Een stand die de bezoeker zelf koos blijft staan; alleen de eerste
        // keer geldt de beginstand uit het ontwerp.
        if (head.hasAttribute("aria-expanded")) return;

        var open = section.dataset.lumediCollapsible !== "closed";
        head.setAttribute("aria-expanded", open ? "true" : "false");
        body.hidden = !open;
      });
    }

    sections.forEach(function (section) {
      var head = section.querySelector(".lumedi-product-info__section-head");
      var body = section.querySelector(".lumedi-product-info__section-body");
      if (!head || !body) return;

      head.setAttribute("aria-controls", body.id);
      head.addEventListener("click", function () {
        if (!head.hasAttribute("aria-expanded")) return;

        var open = head.getAttribute("aria-expanded") === "true";
        head.setAttribute("aria-expanded", open ? "false" : "true");
        body.hidden = open;
      });
    });

    if (mobile.addEventListener) {
      mobile.addEventListener("change", apply);
    } else if (mobile.addListener) {
      mobile.addListener(apply);
    }

    apply();
  }

  function setupTabs(root) {
    root.querySelectorAll("[data-lumedi-tab]").forEach(function (tab) {
      tab.addEventListener("click", function (event) {
        var id = tab.getAttribute("href").replace("#", "");
        var section = root.querySelector("#" + id);
        if (!section) return;

        event.preventDefault();

        // Dichtgeklapt kopje eerst openzetten.
        var head = section.querySelector(".lumedi-product-info__section-head");
        var body = section.querySelector(".lumedi-product-info__section-body");
        if (head && body && head.getAttribute("aria-expanded") === "false") {
          head.setAttribute("aria-expanded", "true");
          body.hidden = false;
        }

        scrollToHeading(section);
      });
    });
  }

  function setupReadMore(root) {
    var description = root.querySelector("[data-lumedi-description]");
    if (!description) return;

    var text = description.querySelector(
      ".lumedi-product-info__description-text",
    );
    var button = description.querySelector(".lumedi-product-info__read-more");
    if (!text || !button) return;

    var moreLabel = button.dataset.labelMore || button.textContent.trim();
    var lessLabel = button.dataset.labelLess || moreLabel;

    function measure() {
      if (description.classList.contains("is-open")) return;
      description.classList.toggle(
        "is-short",
        text.scrollHeight <= text.clientHeight + 1,
      );
    }

    button.addEventListener("click", function () {
      var open = description.classList.toggle("is-open");
      button.textContent = open ? lessLabel : moreLabel;
      button.setAttribute("aria-expanded", open ? "true" : "false");
      if (!open) measure();
    });

    window.addEventListener("resize", measure);
    measure();

    // De letters komen met font-display: swap binnen, dus daarna nog een keer.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }
  }

  function setupVideo(root) {
    var frame = root.querySelector("[data-lumedi-video-frame]");
    if (!frame) return;

    var slides = Array.prototype.slice.call(
      frame.querySelectorAll("[data-lumedi-video-slide]"),
    );
    if (!slides.length) return;

    slides.forEach(function (slide) {
      var poster = slide.querySelector("[data-lumedi-video-poster]");
      if (!poster) return;

      poster.addEventListener("click", function () {
        var src = poster.dataset.lumediVideoPoster;
        if (!src) return;

        var player = document.createElement("iframe");
        player.src = src;
        player.title = poster.dataset.videoTitle || "";
        player.allow =
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        player.setAttribute("allowfullscreen", "");

        poster.hidden = true;
        slide.appendChild(player);
      });
    });

    var current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        // De speler weghalen zet de video stil en zet de poster terug.
        if (i !== current) {
          var player = slide.querySelector("iframe");
          if (player) {
            player.remove();
            var poster = slide.querySelector("[data-lumedi-video-poster]");
            if (poster) poster.hidden = false;
          }
        }
        slide.hidden = i !== current;
      });
    }

    frame.querySelectorAll("[data-lumedi-video-nav]").forEach(function (nav) {
      nav.addEventListener("click", function () {
        show(current + (nav.dataset.lumediVideoNav === "prev" ? -1 : 1));
      });
    });
  }

  function setupReviews(root) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll("[data-lumedi-review-slide]"),
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll("[data-lumedi-review-dot]"),
    );
    if (dots.length !== slides.length) return;

    var current = 0;

    function show(index) {
      // Rondlopen, zodat de pijltjes nooit doodlopen.
      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.hidden = i !== current;
      });

      dots.forEach(function (dot, i) {
        if (i === current) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        show(index);
      });
    });

    root.querySelectorAll("[data-lumedi-review-nav]").forEach(function (nav) {
      nav.addEventListener("click", function () {
        show(current + (nav.dataset.lumediReviewNav === "prev" ? -1 : 1));
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.lumediProductInfoReady) return;
    root.dataset.lumediProductInfoReady = "true";

    setupSections(root);
    setupTabs(root);
    setupReadMore(root);
    setupVideo(root);
    setupReviews(root);
  }

  function initAll() {
    document.querySelectorAll("[data-lumedi-product-info]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-lumedi-product-info]").forEach(init);
  });
})();
